module.exports = __webpack_public_path__ + "img/top_img.f83c60f1.svg";